// Раздел «Спутники»: две вкладки поверх общего маршрута /app/satellites.
//
//   «Карта»          — каталог AIS-приёмных аппаратов, позиции, орбиты, пролёты.
//   «Наблюдаемость»  — когда и где суда молчали (описательно, без объяснения причин).
//
// Вкладка живёт в URL (?tab=observability), как и остальное состояние кабинета:
// ссылку на конкретный вид можно переслать. Карта монтируется только на своей
// вкладке — MapLibre инициализируется в эффекте при монтировании, и держать её
// живой в скрытом div'е незачем.

import { useSearchParams } from 'react-router-dom'
import { useT } from '../i18n'
import { ObservabilityPanel } from '../observability/ObservabilityPanel'
import { SatellitesPage } from './SatellitesPage'

const TABS = [
  { key: 'map', labelKey: 'satellites.tab.map' },
  { key: 'observability', labelKey: 'satellites.tab.observability' },
] as const

export function SatellitesSection() {
  // Имя `tr`, а не `t`: ниже `t` — элемент TABS в map().
  const tr = useT()
  const [params, setParams] = useSearchParams()
  const tab = params.get('tab') === 'observability' ? 'observability' : 'map'

  const select = (key: string) => {
    const next = new URLSearchParams(params)
    // Значение по умолчанию в URL не пишем — ссылка на карту остаётся чистой.
    if (key === 'map') next.delete('tab')
    else next.set('tab', key)
    setParams(next, { replace: true })
  }

  return (
    <div className="relative flex h-full w-full flex-col">
      <nav className="flex shrink-0 gap-1 border-b border-hull bg-deep px-3 py-1.5">
        {TABS.map(t => (
          <button
            key={t.key}
            type="button"
            onClick={() => select(t.key)}
            aria-current={tab === t.key ? 'page' : undefined}
            className={`rounded px-3 py-1 text-xs ${
              tab === t.key ? 'bg-sonar/20 text-foam' : 'text-mist hover:text-foam'
            }`}
          >
            {tr(t.labelKey)}
          </button>
        ))}
      </nav>

      <div className="relative min-h-0 flex-1">
        {tab === 'observability' ? <ObservabilityPanel /> : <SatellitesPage />}
      </div>
    </div>
  )
}
